<template>
  <div class="d-flex flex-column align-items-stretch position-relative gap-2">

    <!-- Top Content Row -->
    <div class="d-flex flex-row align-items-stretch">

      <!-- Top-Left Title/Address/Status Labels -->
      <div class="flex-grow-1">
        <div class="d-flex flex-row align-items-start">
          <ListingSourceIcon :listing="value" class="mt-1 me-2"/>
          <div class="d-flex flex-column align-items-start">
            <div class="fw-semibold">
              {{ value.listingTitle }}
            </div>
            <div v-if="value.listingHost" class="small">Hosted by {{ value.listingHost}}</div>
            <StatusBadge v-if="value.isInactive" variant="danger">Inactive</StatusBadge>
            <StatusBadge v-if="value.data?.listingPresence?.needsReview" variant="warning">Needs absence review</StatusBadge>
            <StatusBadge v-else-if="value.data?.listingPresence?.state === 'missing'" variant="warning">Missing from latest extract</StatusBadge>
            <div v-if="value.isWhitelisted" class="small text-warning">
              <i class="bi bi-clock me-1" />
              Deferred{{ value.deferralEndDate ? ` until ${value.deferralEndDate.format('MMM D, YYYY')}` : ' indefinitely' }}
            </div>
            <div v-else-if="value.hasEndedDeferral" class="small text-muted">
              <i class="bi bi-clock-history me-1" />
              Deferral ended{{ value.deferralEndDate ? ` ${value.deferralEndDate.format('MMM D, YYYY')}` : '' }}
            </div>
            <div class="d-flex flex-row gap-2 align-items-center" v-if="value.dateFirstFound">
              <div v-if="!value.isSeen" class="rounded-pill bg-primary text-white small px-2">
                New
              </div>
              <div :class="`text-${value.isSeen ? 'muted' : 'primary'} small`">
                Found {{ formatDate(value.dateFirstFound) }}
              </div>
            </div>
            <div class="text-muted small" v-else-if="value.dateLoadedFormatted">
              Checked {{ value.dateLoadedFormatted }}
            </div>
            <div class="text-muted small" v-if="value.isPropertyVerified">
              Verified: {{ value.addressFormatted || 'Unspecified' }}
            </div>
          </div>
        </div>
      </div>

      <!-- Image -->
      <ListThumbnail v-if="value.city?.imageCachingEnabled" :src="value.thumbnailUrl" :fallback-src="value.primaryImage" :width="compact ? 56 : 84" :height="compact ? 74 : 111" class="ms-3" />
      <img v-else :style="`${imageSizeStyle};object-fit:cover`" class="rounded ms-3" :src="value.primaryImage" alt="" />
    </div>


  </div>
</template>

<script>
import {Listing} from "@/models/Listing";
import ListingSourceIcon from "@/components/common/ListingSourceIcon.vue";
import StatusBadge from "@/components/common/StatusBadge.vue";
import ListThumbnail from "@/components/common/ListThumbnail.vue";

export default {
  components: {
    ListingSourceIcon,
    StatusBadge,
    ListThumbnail
  },
  props: {
    value: Listing,
    hideAddress: Boolean,
    compact: Boolean
  },
  emits: ['click', 'input', 'street_view'],
  computed: {
    imageSizeStyle() {
      return this.compact ? 'max-width:56px;max-height:74px;' : 'max-width:84px;max-height:111px;';
    }
  }
}
</script>
